import { Component, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Component({
  selector: 'app-prevention-modal',
  templateUrl: './prevention-modal.component.html',
  styleUrls: ['./prevention-modal.component.css']
})
export class PreventionModalComponent {
  
  private open: BehaviorSubject<boolean> = new BehaviorSubject(false);  
}



// WEBPACK FOOTER //
// ./src/app/prevention-modal/prevention-modal.component.ts